<template>
    <div class="column">
        <table class="table is-striped is-narrow is-hoverable is-scrollable is-fullwidth">
            <thead>
            <tr>
                <th><span class="link">#ID</span></th>
                <th><span class="link">User</span></th>
                <th><span class="link">Manager</span></th>
                <th><span class="link">Description</span></th>
                <th><span class="link">Date</span></th>
            </tr>
            </thead>
            <tbody>
                <invoice-table-row></invoice-table-row>
            </tbody>
        </table>
    </div>
</template>

<script>
    import InvoiceTableRow from './InvoiceTableRow.vue'
    export default {
        components: {
            InvoiceTableRow
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/InvoicesTable.vue